import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useProfile } from '../context/ProfileContext';

const PaywallModal = () => {
  const { isLimitReached, activateSubscription } = useProfile();
  const [showActivation, setShowActivation] = useState(false);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  if (!isLimitReached) return null;

  const handleActivate = (e) => {
    e.preventDefault();
    if (code.toUpperCase() === 'CRUISEPRO2025') {
      activateSubscription();
    } else {
      setError('Invalid activation code. Please try again.');
      setTimeout(() => setError(''), 3000);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="absolute inset-0 bg-slate-900/80 backdrop-blur-md"
      />
      
      <motion.div 
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden"
      >
        <div className="bg-blue-600 p-8 text-center text-white">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4">
            <SafeIcon name="Lock" className="w-8 h-8" />
          </div>
          <h2 className="text-2xl font-bold mb-2">You've Used Your 10 Free Generations</h2>
          <p className="text-blue-100 italic">Unlock unlimited access and keep saving hours every week</p>
        </div>

        <div className="p-8">
          <div className="space-y-4 mb-8">
            <div className="flex items-start gap-3">
              <div className="mt-1 bg-green-100 p-1 rounded-full">
                <SafeIcon name="Check" className="w-3 h-3 text-green-600" />
              </div>
              <p className="text-slate-700 font-medium">Unlimited Lead Converter emails</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="mt-1 bg-green-100 p-1 rounded-full">
                <SafeIcon name="Check" className="w-3 h-3 text-green-600" />
              </div>
              <p className="text-slate-700 font-medium">Unlimited Journey Builder calendars</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="mt-1 bg-green-100 p-1 rounded-full">
                <SafeIcon name="Check" className="w-3 h-3 text-green-600" />
              </div>
              <p className="text-slate-700 font-medium">Unlimited Compare & Pitch narratives</p>
            </div>
          </div>

          {!showActivation ? (
            <div className="space-y-4">
              <a 
                href="https://buy.stripe.com/7sY4gz8Pjc7CgwO2rY7EQ00" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block w-full bg-blue-600 hover:bg-blue-700 text-white text-center font-bold py-4 rounded-xl shadow-lg shadow-blue-200 transition-all active:scale-[0.98]"
              >
                Subscribe for $19/month
              </a>
              <button 
                onClick={() => setShowActivation(true)}
                className="w-full text-slate-500 text-sm hover:text-blue-600 transition-colors"
              >
                Already subscribed? <span className="underline font-medium">Click here to activate</span>
              </button>
            </div>
          ) : (
            <motion.form 
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              onSubmit={handleActivate} 
              className="space-y-4"
            >
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Enter Activation Code</label>
                <input 
                  type="text" 
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none uppercase tracking-widest text-center font-mono"
                  placeholder="XXXX-XXXX-XXXX"
                  autoFocus
                />
              </div>
              {error && <p className="text-red-500 text-sm text-center font-medium">{error}</p>}
              <div className="flex gap-3">
                <button 
                  type="button"
                  onClick={() => setShowActivation(false)}
                  className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold py-3 rounded-xl transition-all"
                >
                  Back
                </button>
                <button 
                  type="submit"
                  className="flex-[2] bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-xl transition-all"
                >
                  Activate Now
                </button>
              </div>
            </motion.form>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default PaywallModal;